import { parse } from 'graphql';

import type { RetentionLinkType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

type SendRetentionLinkMutation = {
  sendRetentionLinkEmail?: RetentionLinkType;
  sendRetentionLinkSms?: RetentionLinkType;
};

type SendRetentionLinkMutationVariables = {
  callerId: string;
};

const retentionLinkFields = `
  autoDeactivatePerformedAt
  autoDeactivateScheduledAt
  callerId
  callerResolution
  callerResolvedAt
  createdAt
  createdBy
  emailSentAt
  id
  link
  smsSentAt
  updatedAt
`;

const sendRetentionLinkSmsDocument = parse(`
  mutation SendRetentionLinkSms($callerId: String!) {
    sendRetentionLinkSms(callerId: $callerId) {
      ${retentionLinkFields}
    }
  }
`);

const sendRetentionLinkEmailDocument = parse(`
  mutation SendRetentionLinkEmail($callerId: String!) {
    sendRetentionLinkEmail(callerId: $callerId) {
      ${retentionLinkFields}
    }
  }
`);

const sendRetentionLink = async (
  channel: 'sms' | 'email',
  callerId: string,
) => {
  const response = await mutationExecute<SendRetentionLinkMutation, SendRetentionLinkMutationVariables>({
    mutation: channel === 'sms' ? sendRetentionLinkSmsDocument : sendRetentionLinkEmailDocument,
    variables: { callerId },
  });

  return channel === 'sms' ? response.data?.sendRetentionLinkSms : response.data?.sendRetentionLinkEmail;
};

export const sendRetentionLinkSms = (callerId: string) => sendRetentionLink('sms', callerId);
export const sendRetentionLinkEmail = (callerId: string) => sendRetentionLink('email', callerId);
